// extracted by mini-css-extract-plugin
export default {"primaryColor":"#173753","secondaryColor":"#fff","complementaryColorDark":"#173753","complementaryColorLight":"#6d98ba"};